import React from 'react'
import { neoskop } from '../../../content/neoskop'
import Spacer from '../../layouts/Spacer'
import PhoneNumber from '../PhoneNumber'
import SocialLinks from '../SocialLinks'
import './styles.scss'

const ContactArea = () => (
  <div className="contact-area">
    <PhoneNumber number="0511 - 700 208 - 0" variant="neutral" size="small" />
    <Spacer size={'s'} when={{ md: 'm' }} />
    <SocialLinks links={[{ icon: 'instagram', to: neoskop.social.instagram.url }]} size="small" color="black" />
  </div>
)

export default ContactArea
